import { getNumber } from '@utils/Format'

export const toNumberOrNull = (value) => {
  if (value === undefined || value === null || value === '') return null
  const parsed = getNumber(value)
  return Number.isFinite(parsed) ? parsed : null
}
